import { CMSContent } from 'components/misc';
import dictionary from 'config/dictionary';
import { connect } from 'react-redux';
import { fetchTerms, getTerms, getTermsError } from 'redux/modules/brand';
import { fetchHuggg, getHuggg } from 'redux/modules/huggg';

const mapStateToProps = (state) => ({
  content: getTerms(state),
  error: getTermsError(state),
  huggg: getHuggg(state),
  title: dictionary.brandTermsTitle,
});

export default connect(mapStateToProps, {
  fetchContent: fetchTerms,
  fetchHuggg,
})(CMSContent);
